(function () {
    let resetInCorso = false;
    let needs_reset = false; 
    
    // La variabile in memoria per tracciare lo svuotamento del testo
    let deveResettareTesto = false;

    // --- INTERCETTAZIONE DELLE CHIAMATE AJAX (XHR) ---
    const originalXHROpen = XMLHttpRequest.prototype.open;
    const originalXHRSend = XMLHttpRequest.prototype.send;

    function resetToFirstStep() {
        let clicks = 0;
        const maxClicks = 15;

        const interval = setInterval(() => {
            const prevBtn = document.querySelector('.csh-product-customizer-modal__nav-btn--prev');
            
            if (prevBtn && !prevBtn.disabled && clicks < maxClicks) {
                prevBtn.click();
                clicks++;
            } else {
                clearInterval(interval);
                resetInCorso = false; 
            }
        }, 120);
    }

    // Funzione atomica di controllo e reset
    function controllaEResettaTextarea() {
        if (!deveResettareTesto) return;

        const textarea = document.querySelector('textarea[name="properties[Testo personalizzato]"]');
        if (textarea) {
            textarea.value = '';
            textarea.dispatchEvent(new Event('input', { bubbles: true }));
            textarea.blur();
            
            deveResettareTesto = false; // Reset dello stato immediato
        }
    }

    // Ascoltiamo le interazioni sulla modale per intercettare il rendering del primo step
    document.body.addEventListener('click', (e) => {
        if (e.target.closest('.csh-product-customizer-modal') || e.target.closest('.csh-product-customizer-modal__nav-btn--prev')) {
            setTimeout(controllaEResettaTextarea, 50);
        }
    });

    document.body.addEventListener('input', (e) => {
        if (e.target.closest('.csh-product-customizer-modal')) {
            controllaEResettaTextarea();
        }
    });

    XMLHttpRequest.prototype.open = function(method, url) {
        this._url = typeof url === 'string' ? url : url?.toString() || '';
        return originalXHROpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function() {
        if (this._url) {
            const isCartAdd = this._url.includes('/cart/add.js') || this._url.includes('/cart/add');
            const isCustomilySave = this._url.includes('images/preview/save');

            if (isCartAdd || isCustomilySave) {
                this.addEventListener('load', function() {
                    if (this.status >= 200 && this.status < 300) {
                        needs_reset = true; 
                        deveResettareTesto = true; // Alziamo la let di stato al successo della rete
                        
                        if (needs_reset && !resetInCorso) {
                            resetInCorso = true;
                            needs_reset = false; 
                            resetToFirstStep();
                        }
                    }
                });
            }
        }
        return originalXHRSend.apply(this, arguments);
    };
})();